import React from "react";

const StatusBanner = ({ variant = "info", title, message }) => {
  const styles = {
    error: "bg-red-50 border-red-200 text-red-800",
    warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
    info: "bg-blue-50 border-blue-200 text-blue-800",
  };

  return (
    <div
      className={`p-4 rounded-lg border mb-6 ${styles[variant] || styles.info}`}
    >
      <h3 className="font-semibold text-sm">{title}</h3>
      {message && <p className="text-sm mt-1 opacity-90">{message}</p>}
    </div>
  );
};

export default StatusBanner;
